import { createFileRoute } from "@tanstack/react-router";
import CheckoutSuccess from "@/pages/CheckoutSuccess";
import { buildNoindexHead, noindexLoader, type NoindexSEO } from "@/lib/noindex-route-seo";

const TITLES: NoindexSEO = {
  "es": "Reserva confirmada",
  "pt-BR": "Reserva confirmada",
  "en": "Booking confirmed",
  "en-EU": "Booking confirmed",
};

export const Route = createFileRoute("/checkout/success")({
  loader: noindexLoader,
  head: ({ loaderData }) => buildNoindexHead(TITLES, "/checkout/success", loaderData),
  component: CheckoutSuccess,
});
